import React, { Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InformationOutline from "mdi-material-ui/InformationOutline";

const ModalMessage = ({ visible, close, title, description }) => {
  return (
    <Fragment>
      <Dialog
        open={visible}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ className: "sp-modal__paper" }}
      >
        <DialogContent className="sp-modal sp-modal--left">
          <div className="sp-modal__head">
            <span className="sp-modal__icon">
              <InformationOutline />
            </span>
            <h2 id="alert-dialog-title" className="sp-modal__title">
              {title}
            </h2>
          </div>
          <div id="alert-dialog-description" className="sp-modal__body">
            {description}
          </div>
        </DialogContent>
        <DialogActions className="sp-modal__actions">
          <button type="button" className="sp-modal__btn sp-modal__btn--primary" onClick={close}>
            Fechar
          </button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ModalMessage;
